import React from 'react';
import Image from 'react-bootstrap/Image';
import Header from './Header';
import Slide from 'react-reveal/Slide';

const Servicios = (props) => {



    return (
        <div className="col-md-12">
            <Slide top>
                <div className='fixed-top' >
                    <Header />
                </div>
            </Slide>
            <div className='col-md-12 contenedor-principal container-fluid p-0' id='contenedorTotal' >
                {/*  <img className='img-fluid' src='imagenes/compu1.jpg' /> */}
                <div className='hover-principal mx-auto row'></div>
                <Slide top>
                    <div className='contenedor-principal-content row contenedor-fluid'>


                        <h1 className='text-center fw-bold mt-5'>QUIENES SOMOS</h1>





                    </div>
                </Slide>

            </div>

            <div className='col-md-12 mx-auto row py-5'>

                <Slide bottom>

                    <h1 className='text-center mt-5'>Sistemas y Gerencia de Recursos (SYGRECA)</h1>

                    <div className='col-md-8 mx-auto'>
                        <h3 className='text-center'>
                            Somos una empresa lider de soluciones y aplicaciones informaticas de gestion administrativa y tributaria en el sector publico, ofreciendo un servicio de calidad y una continua actualización tecnologica.
                        </h3>
                    </div>
                </Slide>

                {/* div numero 1 */}

                <Slide bottom>
                    <div className='col-md-12 row mx-auto mt-5'>

                        <div className='col-md-6'>

                            <img className='card-img mx-auto img-fluid' src='imagenes/experiencia.jpg' />




                        </div>

                        <div className='col-md-4 mx-auto padre'>
                            <h3 className='hijo'>Contamos con más de 22 años de experiencia atendiendo al sector público, prestando nuestros servicios de ventas de equipos informáticos, configuración e instalación de redes de datos, cobranzas de impuestos, asesoría legal, administración tributaria.</h3>
                        </div>




                    </div>

                </Slide>

                {/* div numero 2 */}

                <Slide bottom>
                    <div className='col-md-12 row mx-auto mt-5'>



                        <div className='col-md-4 mx-auto padre'>
                            <h3 className='hijo'>
                                Somos un grupo multidisciplinario de profesionales, dedicados a crear e implementar soluciones innovadoras para las instituciones públicas, nuestros trabajos abarcan desde las asesorías en las áreas tributarias y fiscal hasta la implementación de sistemas y plataformas tecnológicas sólidas acordes con el crecimiento de las instituciones.
                            </h3>
                        </div>


                        <div className='col-md-6'>

                            <img className='card-img mx-auto img-fluid' src='imagenes/disiplina.jpg' />




                        </div>

                    </div>

                </Slide>





                {/* div numero 3 */}

                <Slide bottom>
                    <div className='col-md-12 row mx-auto mt-5'>

                        <div className='col-md-6'>

                            <img className='card-img mx-auto img-fluid' src='imagenes/desarrollar.jpg' />




                        </div>

                        <div className='col-md-4 mx-auto padre'>
                            <h3 className='hijo'>
                                Sygre C.A. a desarrollado OPEN-SIAP, un sistema integrado para la gestión administrativa de las organizaciones del sector público, cuenta con una gran experiencia de implementación, madurez y crecimiento, proporcionando a nuestros clientes, soluciones adaptadas a su medida, cumpliendo con la normativa legal vigente que rigen para el sector de la administración pública.
                            </h3>
                        </div>




                    </div>

                </Slide>


            </div>

            <div class="social">
		<ul>
			<li><a href="http://www.facebook.com/falconmasters" target="_blank" class="icon-facebook"><i class="fa-brands fa-facebook"></i></a></li>
			<li><a href="http://www.twitter.com/falconmasters" target="_blank" class="icon-twitter"><i class="fa-brands fa-twitter"></i></a></li>
			<li><a href="http://www.pinterest.com/falconmasters" target="_blank" class="icon-pinterest"><i class="fa-brands fa-youtube"></i></a></li>
			<li><a href="mailto:contacto@falconmasters.com" class="icon-mail"><i class="fa-solid fa-envelope"></i></a></li>
		</ul>
	</div>
        </div>

    );
};

export default Servicios;


// WEBPACK FOOTER //
// ./src/components/servicios.js